<template>
  <m-dialog ref="dlg" @save="save" :title="'Tambah Ajuan Cuti'">
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" sm="10" md="7" lg="7" xl="7">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="6" sm="12">
                <label class="caption mb-2 primary--text"> Pilih Kategori Persetujuan </label>
                <v-select
                  v-model="form.cuti_kategori_id"
                  :items="kategoris"
                  item-text="nama"
                  item-value="cuti_kategori_id"
                  placeholder="Pilih Kategori"
                  dense
                  outlined
                  data-vv-name="cuti_kategori_id"
                  data-vv-as="Kategori Persetujuan"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.cuti_kategori_id')"
                  no-data-text="Belum tersedia kategori ketidakhadiran atau Anda belum termasuk dalam klasifikasi"
                ></v-select>
              </v-col>
              <v-col v-if="form.cuti_kategori_id" cols="12" md="6" sm="12">
                <label class="caption mb-2 primary--text">
                  <v-icon small color="primary">mdi-briefcase</v-icon>
                  {{ getDeepObj(itemKategori, 'nama') }}
                </label>
                <div
                  v-if="Number(getDeepObj(itemKategori, 'is_saldo')) === 1"
                  class="my-2 d-flex justify-space-between"
                >
                  <div class="primary--text mt-1">
                    Digunakan:
                    <span
                      :class="`body-1 ${
                        Number(cutiDurasi) > Number(getDeepObj(itemKategori, 'sisa') || 0) ? 'red--text' : ''
                      }`"
                    >
                      {{ cutiDurasi }} Hari
                    </span>
                  </div>
                  <div>
                    <span class="body-1 primary--text">
                      <span class="text-h6"> {{ getDeepObj(itemKategori, 'sisa') || 0 }} </span>/
                      {{ getDeepObj(itemKategori, 'total') || 0 }} Hari</span
                    >
                  </div>
                </div>
                <div v-else class="my-2 d-flex justify-space-between">
                  <div class="primary--text mt-1">
                    Digunakan:
                    <span :class="`body-1`"> {{ cutiDurasi }} Hari </span>
                  </div>
                  <div>
                    <span class="body-1 primary--text">
                      <span class="text-h6"> &infin; Hari</span>
                    </span>
                  </div>
                </div>
              </v-col>
              <v-col class="my-3" cols="12" md="12" sm="12"> </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2 primary--text">Tanggal Mulai</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Awal"
                  v-model="form.tgl_awal"
                  hint="Tanggal Awal"
                  :max="form.tgl_akhir"
                  data-vv-name="tanggalAwal"
                  data-vv-as="Tanggal Mulai"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAwal')"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" sm="12" md="6" lg="6" class="py-0">
                <label class="caption mb-2 primary--text">Tanggal Selesai</label>
                <m-datepicker
                  dense
                  single-line
                  outlined
                  label="Tanggal Selesai"
                  v-model="form.tgl_akhir"
                  :min="form.tgl_awal"
                  hint="Tanggal Akhir"
                  data-vv-name="tanggalAkhir"
                  data-vv-as="Tanggal Selesai"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.tanggalAkhir')"
                ></m-datepicker>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <label class="caption mb-2 primary--text">Keterangan</label>
                <v-textarea
                  v-model="form.keterangan"
                  placeholder="Keterangan"
                  rows="2"
                  dense
                  outlined
                  data-vv-name="keterangan"
                  data-vv-as="Keterangan"
                  v-validate.persist="'required'"
                  :error-messages="errors.collect('form.keterangan')"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <template v-if="detail.lampiran">
                  <label class="caption mb-2">Lampiran Berkas</label>
                  <v-text-field dense outlined readonly v-model="detail.lampiran">
                    <template v-slot:append-outer>
                      <v-btn icon small @click="deleteLampiran"><v-icon>mdi-close</v-icon></v-btn>
                    </template>
                  </v-text-field>
                  <v-btn color="orange" small dark @click="onShowBerkas">Lihat berkas</v-btn>
                </template>
                <template v-else>
                  <MFileInput v-model="lampiran" label="Lampiran" :max="2000" :accept="['.jpg, .png, .pdf']" />
                </template>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>

<script>
import { toYMD } from '@/tools'
import MFileInput from '../../../components/MFileInput'
import moment from 'moment'
export default {
  $_veeValidate: {
    validator: 'new',
  },

  props: {
    kategoris: {
      type: Array,
      default: () => [],
    },
  },

  components: {
    MFileInput,
  },

  data() {
    return {
      form: {},
      id: null,
      detail: {},
      lampiran: null,
    }
  },
  computed: {
    itemKategori() {
      return this.kategoris.find((s) => s.cuti_kategori_id === Number(this.form.cuti_kategori_id)) || {}
    },

    cutiDurasi() {
      if (!this.form.tgl_awal || !this.form.tgl_akhir) return 0

      let start = moment(this.form.tgl_awal)
      let end = moment(this.form.tgl_akhir)
      let diffDays = moment.duration(end.diff(start)).asDays()

      if (diffDays < 0) {
        return 0
      }

      return diffDays + 1
    },
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.reset()
      this.$validator.reset()
      this.$refs.dlg.open()

      if (obj) {
        this.initForm(obj)
      }
    },
    initForm(obj) {
      this.id = obj.cuti_id
      this.detail = {}

      this.$set(this.form, 'cuti_kategori_id', obj.cuti_kategori_id)
      this.$set(this.form, 'tgl_awal', toYMD(obj.tgl_awal))
      this.$set(this.form, 'tgl_akhir', toYMD(obj.tgl_akhir))
      this.$set(this.form, 'keterangan', obj.keterangan)
    },
    reset() {
      this.form = {}
      this.id = null
      this.lampiran = null
    },
    onShowBerkas() {
      window.open(this.cuti.lampiran, '_blank')
    },
    deleteLampiran() {
      this.$delete(this.detail, 'lampiran')
      this.$set(this, 'lampiran', null)
    },
    save() {
      this.$validator
        .validateAll('form')
        .then((res) => {
          if (!res) return Promise.reject()
          return res
        })
        .then(() => {
          if (
            Number(this.getDeepObj(this.itemKategori, 'is_saldo') || 0) === 1 &&
            Number(this.getDeepObj(this.itemKategori, 'sisa') || 0) <= 0
          ) {
            this.$error('Saldo Cuti Tidak Mencukupi')
            return Promise.reject()
          } else if (
            Number(this.getDeepObj(this.itemKategori, 'is_saldo') || 0) === 1 &&
            Number(this.cutiDurasi) > Number(this.getDeepObj(this.itemKategori, 'sisa') || 0)
          ) {
            this.$error('Saldo Cuti Tidak Mencukupi')
            return Promise.reject()
          }
        })
        .then(() => {
          let form = { ...this.form }
          let url = 'cuti/saveAjuan'

          if (!this.getDeepObj(this, 'lampiran.file')) {
            this.$set(form, 'lampiran', this.lampiran)
          }

          const formData = new FormData()
          Object.keys(form).forEach((key) => {
            if (form[key]) {
              formData.append(key, form[key])
            }
          })

          if (this.id) {
            url = 'cuti/editAjuan'
          }

          this.$store
            .dispatch(url, {
              organisasi_id: this.organisasi_id,
              cuti_id: this.id,
              obj: { params: formData },
            })
            .then(() => {
              this.$success(`Ajuan Cuti berhasil di ${this.id ? 'ubah' : 'tambahkan'}`)
              this.$emit('reload')
              this.$refs.dlg.resolve()
            })
        })
        .catch((e) => e)
    },
  },
}
</script>
